import { useContext } from "react";
import AuthContext, { AuthContextValue } from "../contexts/auth.context";

const useAuth = (): AuthContextValue => useContext(AuthContext);

export default useAuth;
